import { useOutletContext } from "react-router-dom";
import * as api from "../../api/client";
import { usePolledResource } from "../../hooks/usePolling";
import { MessageLogsList } from "../../components/MessageLogsList";
import type { ServerOutletContext } from "../ServerLayout";

const POLL_INTERVAL_MS = 20_000;

export function ServerMessageLogsTab() {
  const { detail } = useOutletContext<ServerOutletContext>();
  const fetcher = () => api.listMessageLogs(detail.server.id);
  const { data, loading, error } = usePolledResource(fetcher, POLL_INTERVAL_MS, detail.server.id);

  return (
    <div className="panel">
      <div className="panel-header">
        <h2>Message logs</h2>
      </div>
      {error && <div className="form-error">{error}</div>}
      {loading ? <p className="muted">Loading…</p> : <MessageLogsList logs={data?.logs ?? []} />}
    </div>
  );
}
